import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

import { RewardsStyleVariant, WithStyleVariant } from '../types';

export const CategoryContainer = styled.div<WithStyleVariant>`
  padding: 0 ${primitive.$spacing4};
  border-width: 1px;
  border-style: solid;
  border-color: ${({ variant, theme }) =>
    variant === RewardsStyleVariant.Secondary
      ? primitive.th.$alwaysRedDarken10
      : theme.token('border-color-pattern-default')};
  border-radius: 0.25rem;
  background-color: ${({ variant, theme }) =>
    variant === RewardsStyleVariant.Secondary
      ? primitive.th.$alwaysRedDarken10
      : theme.token('background-pattern')};
`;
